import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";

const initialState = {
  user: null,
  authenticated: null,
};

const slice = createSlice({
  name: "userProvider",
  initialState,
  reducers: {
    setAuthenticated(state, action) {
      state.authenticated = action.payload.authenticated;
      state.user = action.payload.user;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export const { actions } = slice;

export function setAuthenticated(authenticated) {
  return () => {
    dispatch(slice.actions.setAuthenticated(authenticated));
  };
}

export function setUser(user) {
  return () => {
    dispatch(slice.actions.setUser(user));
  };
}
